var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c(_vm.tag,_vm._b({tag:"component",staticClass:"slide"},'component',_vm.props,false),[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}],attrs:{"rel":"noopener"}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }